import React from "react";
import "./ReusableHeader.scss";

interface ReusableHeaderProps {
  id?: string;
  className?: string;
  style?: React.CSSProperties;
  title?: React.ReactNode;
  leftSection?: React.ReactNode;
  rightSection?: React.ReactNode;
  containerClassName?: string;
}

const ReusableHeader: React.FC<ReusableHeaderProps> = ({
  id,
  className,
  style,
  title,
  leftSection,
  rightSection,
  containerClassName = "header-main",
}) => {
  return (
    <header id={id} className={className} style={style}>
      <div className={containerClassName}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            minWidth: 0,
            justifyContent: "flex-start",
            gap: "0.5vw",
          }}
        >
          {leftSection}
          <p className="header-title">{title}</p>
        </div>
        <div className="common-header-right">{rightSection}</div>
      </div>
    </header>
  );
};

export default ReusableHeader;
